import { getModernColorThemes } from '../utils/getModernThemes';
import { getThemeIdFromParameter } from '../utils/optionalArgumentHelpers';

export default function getIsCurrentThemeModernColor(themeId?: string): boolean {
    themeId = getThemeIdFromParameter(themeId);

    return getModernColorThemes().includes(themeId);
}
